// A crashed or timed-out serverless function answers with plain text (for
// example Vercel's "An error occurred with your deployment..."), and calling
// response.json() on that surfaces a baffling "Unexpected token 'A'... is not
// valid JSON" to the user. Every fetch in the app should parse bodies through
// readJson so a platform hiccup reads like one.
export const SERVER_HICCUP =
  "The server had a temporary problem. Please refresh and try again.";

export async function readJson(response: Response): Promise<any> {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(SERVER_HICCUP);
  }
}
